<template>
    <img v-if="row.bank" :src="BankLogo(row.bank)" width="32" height="28">
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    }
})
</script>

<style>

</style>